// Postal code validation
export const isValidPostalCode = (postalCode, country) => {
  if (!postalCode) return true; // Allow empty
  if (country === "CAN") {
    // Canadian postal code: A1A 1A1 or A1A1A1
    const canadianPattern = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    return canadianPattern.test(postalCode);
  } else if (country === "USA") {
    // US ZIP code: 12345 (5 digits only)
    const usPattern = /^\d{5}$/;
    return usPattern.test(postalCode);
  }
  return true;
};
